import CustomerContactList from "../../components/CustomerContactList";

export default function ContactsPage()  {
  return <CustomerContactList />
}